import { TextType } from "@ifgengineering/component-library";
import { ThemedText } from "@components/ThemedText";
import React from "react";
import styled from "styled-components";
import { ColorType, theme } from "../../../styles/theme";

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label`
  display: flex;
  position: relative;
  cursor: pointer;
  // margin: 0 0.375rem;
  align-items: center;
`;

const Indicator = styled.div<{ checked?: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid
    ${({ checked }) => (checked ? theme.colors.BLUE600 : theme.colors.SLATE500)};
  border-radius: 4px;
  position: relative;
  background-color: ${({ checked }) => checked && theme.colors.BLUE600};

  ${Label}:hover & {
    background: ${theme.colors.BLUE200};
  }

  ${Input}:focus-visible + & {
    outline: 2px solid ${theme.colors.BLUE600};
    outline-offset: 2px;
  }

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0.035rem;
    left: 0.41rem;
    width: 0.44rem;
    height: 0.9rem;
    border: solid ${theme.colors.WHITE};
    border-width: 0 2px 2px 0;
    border-radius: 1px;
    transform: rotate(45deg);
  }
`;

const LabelText = styled(ThemedText)`
  cursor: pointer;
  margin-left: 0.375rem;
`;

type Props = {
  checked: boolean;
  value?: string;
  onChange?: () => void;
  onClick?: () => void;
  label?: string;
  testId?: string;
  labelFontSize?: keyof typeof TextType;
  labelColor?: ColorType;
};

export const Checkbox: React.FunctionComponent<Props> = ({
  value,
  checked,
  onChange,
  onClick,
  label,
  labelFontSize = "P14",
  labelColor = "SLATE700",
  testId,
}) => (
  <Label data-testid={testId}>
    <Input
      type="checkbox"
      value={value}
      checked={checked}
      onChange={onChange}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick();
      }}
    />
    <Indicator checked={checked} />
    <LabelText type={labelFontSize} color={labelColor}>
      {label}
    </LabelText>
  </Label>
);

export default Checkbox;
